"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _theme = _interopRequireDefault(require("../../services/theme"));

var _getStyle2 = _interopRequireDefault(require("../../services/get-style"));

var _wixSdkPolyfill = _interopRequireDefault(require("../../../services/wix-sdk-polyfill"));

var _viewer = require("../../services/viewer");

var _richContentViewer = _interopRequireDefault(require("./rich-content-viewer.scss"));

var _textColorUtils = require("../../services/text-color-utils");

var _searchPageUrl = require("../../services/search-page-url");

var _linkSettings = _interopRequireDefault(require("../../constants/linkSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RicosViewerWrapper = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RicosViewerWrapper, _React$Component);

  function RicosViewerWrapper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: false
    });

    _defineProperty(_assertThisInitialized(_this), "getImagePluginConfig", function () {
      return {
        imageProps: function imageProps(src) {
          return {
            'data-pin-url': _this.props.pageUrl,
            'data-pin-media': (0, _lodash.isString)(src) ? src : _this.props.getImageUrl(src, _viewer.MAX_PINTEREST_IMAGE_SIZE, _viewer.MAX_PINTEREST_IMAGE_SIZE)
          };
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getGalleryPluginConfig", function () {
      var _this$props = _this.props,
          isOOI = _this$props.isOOI,
          isInEditor = _this$props.isInEditor,
          isInPreview = _this$props.isInPreview;
      var useCustomScroll = !isOOI || isOOI && (isInEditor() || isInPreview());

      var galleryScrollingElement = function galleryScrollingElement() {
        return {
          addEventListener: function addEventListener(eventName, callback) {
            _wixSdkPolyfill["default"].addEventListener(eventName.toUpperCase(), callback);
          },
          removeEventListener: function removeEventListener(eventName, callback) {
            _wixSdkPolyfill["default"].removeEventListener(eventName.toUpperCase(), callback);
          }
        };
      };

      return {
        imageProps: function imageProps() {
          return {
            'data-pin-url': _this.props.pageUrl
          };
        },
        scrollingElement: useCustomScroll ? galleryScrollingElement : typeof window !== 'undefined' && window
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getTextColorPluginConfig", function () {
      var _this$props2 = _this.props,
          appSettings = _this$props2.appSettings,
          isHexColor = _this$props2.isHexColor;
      var colorScheme = (0, _textColorUtils.getTextColorSchema)(appSettings);
      return {
        customStyleFn: (0, _textColorUtils.viewerCustomStyleFn)(colorScheme, {
          isHexColor: isHexColor
        }),
        styleSelectionPredicate: (0, _textColorUtils.styleSelectionPredicate)(colorScheme, {
          isHexColor: isHexColor
        })
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getHashtagPluginConfig", function () {
      var _this$props3 = _this.props,
          hashtagNavigate = _this$props3.hashtagNavigate,
          sectionUrl = _this$props3.sectionUrl;
      return {
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          hashtagNavigate((0, _searchPageUrl.createHashtagPath)(event.target.innerText));
        },
        createHref: function createHref(decoratedText) {
          return (0, _searchPageUrl.createHashtagHref)(decoratedText, sectionUrl);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getActionButtonPluginConfig", function () {
      return {
        onClick: _this.props.onButtonClick
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getPlugins", function () {
      var plugins = [_this.props.pluginCodeBlock(), _this.props.pluginDivider(), _this.props.pluginGallery(_this.getGalleryPluginConfig()), _this.props.pluginGiphy(), _this.props.pluginHashtag(_this.getHashtagPluginConfig()), _this.props.pluginHtml(), _this.props.pluginImage(_this.getImagePluginConfig()), _this.props.pluginLineSpacing(), _this.props.pluginLink(), _this.props.pluginTextColor(_this.getTextColorPluginConfig()), _this.props.pluginVideo(), _this.props.pluginFileUpload(), _this.props.pluginHeadersMarkdown(), _this.props.pluginActionButton(_this.getActionButtonPluginConfig())];
      return plugins;
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function (error) {
      if (!_this.state.error) {
        _this.setState({
          error: error
        });
      }
    });

    return _this;
  }

  var _proto = RicosViewerWrapper.prototype;

  _proto.render = function render() {
    if (this.state.error) {
      return this.props.fallback();
    }

    var _this$props4 = this.props,
        WixRicosViewer = _this$props4.WixRicosViewer,
        content = _this$props4.content,
        rceVersion = _this$props4.rceVersion,
        _getTheme = _this$props4.getTheme,
        _getStyle = _this$props4.getStyle,
        isCompact = _this$props4.isCompact,
        appSettings = _this$props4.appSettings,
        isSeo = _this$props4.isSeo,
        isOOI = _this$props4.isOOI,
        isMobile = _this$props4.isMobile,
        locale = _this$props4.locale,
        richContentFontClassName = _this$props4.richContentFontClassName,
        useDescriptionFontInEditor = _this$props4.useDescriptionFontInEditor,
        isPostPageBundle = _this$props4.isPostPageBundle,
        instance = _this$props4.instance,
        css = _this$props4.css;
    var isPostPageEnabled = true;
    var readOnly = true;
    var isViewer = true;
    var isPostPage = isPostPageBundle();
    var plugins = this.getPlugins();

    var cssOverride = _getTheme({
      appSettings: appSettings,
      readOnly: readOnly,
      isCompact: isCompact,
      isViewer: isViewer,
      isSeo: isSeo,
      isOOI: isOOI,
      isMobile: isMobile,
      isPostPageEnabled: isPostPageEnabled,
      richContentFontClassName: richContentFontClassName,
      useDescriptionFontInEditor: useDescriptionFontInEditor,
      isPostPage: isPostPage,
      css: css,
      version: rceVersion
    });

    var style = _getStyle(appSettings, {
      isPostPageEnabled: isPostPageEnabled
    });

    var className = (0, _classnames["default"])(_richContentViewer["default"].container, cssOverride.overrideDefaultTheme, cssOverride.overrideAppSettings);
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: style,
      className: className,
      "data-rce-version": rceVersion
    }, /*#__PURE__*/_react["default"].createElement(WixRicosViewer, {
      plugins: plugins,
      content: content,
      cssOverride: cssOverride,
      locale: locale,
      instance: instance,
      onError: this.onError,
      isMobile: isMobile,
      seoSettings: isSeo,
      linkSettings: _linkSettings["default"]
    }));
  };

  return RicosViewerWrapper;
}(_react["default"].Component);

RicosViewerWrapper.defaultProps = {
  isCompact: false,
  useDescriptionFontInEditor: true,
  fallback: function fallback() {
    return 'Content cannot be displayed';
  },
  getTheme: _theme["default"],
  getStyle: _getStyle2["default"]
};
var _default = RicosViewerWrapper;
exports["default"] = _default;